// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bul_list_sm li[data-v-235ddf9f]::before {\n  content: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
